module.exports = __webpack_public_path__ + "CA.png?17ef24fa9095dd8bc4148f1c23740d36";